import { extend } from 'sk-ui/lib/utils/util.js'

import { action } from 'sky-engine/api/index'

import desktopElementForm from './metaData/desktopElementForm'

import { INDUSTRY_MNG } from '@/api/apiModules'

export default {
  desktopElementCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: desktopElementForm,
      props
    })
  },
  desktopElementEdit({ commit }, params) {
    const props = {
      title: '编辑云桌面元素',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, desktopElementForm)
    var changeList = []
    action(INDUSTRY_MNG, 'list', { limit: 100 }).then(res => {
      for (const iterator of res.data.content.itemArr) {
        changeList.push({
          id: iterator.id,
          value: iterator.id,
          label: iterator.industryName
        })
      }
      editForm.view.content[1].$options = changeList
      this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
    })
  }
}
